/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import React from 'react';
import { Trans } from 'react-i18next';
import { FlowBlockTos as BlockModel } from '@staffino/model';
import { Paragraph, styled } from '@staffino/primitive-controls';

const StyledLink = styled.a({
  display: 'inline-block',
  cursor: 'pointer',
  textDecoration: 'underline',
});

type Props = {
  block: BlockModel;
  color?: string;
  onSelect?: (documentIndex: number) => void;
};
const TosBlock = ({ block, onSelect, color }: Props) => {
  const showPrivacyPolicy = block.privacyPolicyUrl !== false;
  return (
    <Paragraph
      fontSize="0.875rem"
      textAlign="center"
      color={color ?? 'lightText'}
      mt={10}
      display="block"
    >
      {showPrivacyPolicy && (
        <Trans>
          By using the Staffino's Web Application you confirm you were duly
          familiarised with the{' '}
          <StyledLink onClick={() => onSelect?.(0)}>Privacy Policy</StyledLink>.
        </Trans>
      )}
    </Paragraph>
  );
};

export default TosBlock;
